<template>
  <div>
    没有权限！！
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/noAuth.vue